import {
    validateEmail,
    validatePhone
} from '../../../../../utils/formValidation/validationFunctions';
import { validateFirstName } from '../../../validation/validationFunctions';

import {
    validateAddressLine1,
    validateBusinessName,
    validateBusinessPostcode,
    validateCity,
    validateEmploymentTypeId,
    validateHiringManagerLastName,
    validateHiringManagerOfficeNumber,
    validateHourlyPay,
    validateHoursPerWeek,
    validateJobSectorId,
    validateLeadAdviserId,
    validateLeadGeneratedById,
    validateSelfEmploymentClaimCalculationDate,
    validateStartDate,
    validateVacancyTitle
} from './validationFunctions';

export const validate = (newEntry, isLeadAdviser, isSelfEmployment, firstName, lastName) => {
    let newErrors = {};

    newErrors = validateEmploymentTypeId(newEntry.employmentTypeId, newErrors);
    if (isSelfEmployment)
        newErrors = validateSelfEmploymentClaimCalculationDate(
            newEntry.selfEmploymentClaimCalculationDate,
            newErrors,
            newEntry?.startDate
        );
    newErrors = validateStartDate(newEntry.startDate, newErrors, true);
    newErrors = validateVacancyTitle(newEntry?.vacancyTitle, newErrors);
    newErrors = validateHourlyPay(newEntry.hourlyPay, newErrors);
    newErrors = validateHoursPerWeek(
        newEntry.hoursPerWeek,
        newEntry.hoursPerWeekId,
        newErrors,
        newEntry.fixedFlexibleHour
    );
    newErrors = validateJobSectorId(newEntry.jobSectorId, newErrors);
    newErrors = validateBusinessName(newEntry.businessName, newErrors);
    newErrors = validateLeadGeneratedById(newEntry.leadGeneratedById, newErrors);
    if (isLeadAdviser) newErrors = validateLeadAdviserId(newEntry.leadAdviserId, newErrors);
    newErrors = validateFirstName(firstName, newErrors);
    newErrors = validateHiringManagerLastName(lastName, newErrors);
    newErrors = validateHiringManagerOfficeNumber(newEntry.hiringManagerOfficeNumber, newErrors);
    if (newEntry.hiringManagerMobileNumber) {
        newErrors = validatePhone(
            newEntry.hiringManagerMobileNumber,
            newErrors,
            'hiringManagerMobileNumber'
        );
    }
    if (newEntry.hiringManagerEmail)
        newErrors = validateEmail(newEntry.hiringManagerEmail, newErrors, 'hiringManagerEmail');
    newErrors = validateAddressLine1(newEntry.addressLine1, newErrors);
    newErrors = validateCity(newEntry.city, newErrors);
    newErrors = validateBusinessPostcode(newEntry.postcode, newErrors);

    return newErrors;
};
